import "@/App.css";
import { Toaster } from "sonner";
import { useLenis } from "@/hooks/useLenis";
import { Nav } from "@/components/Nav";
import { Hero } from "@/components/Hero";
import { Ribbon } from "@/components/Ribbon";
import { Practice } from "@/components/Practice";
import { UrgentBail } from "@/components/UrgentBail";
import { About } from "@/components/About";
import { Team } from "@/components/Team";
import { Approach } from "@/components/Approach";
import { CaseHighlights } from "@/components/CaseHighlights";
import { Reviews } from "@/components/Reviews";
import { Gallery } from "@/components/Gallery";
import { Blog } from "@/components/Blog";
import { Contact } from "@/components/Contact";
import { Footer } from "@/components/Footer";

function App() {
  useLenis();
  return (
    <div className="App grain">
      <Nav />
      <main>
        <Hero />
        <Ribbon />
        <Practice />
        <UrgentBail />
        <About />
        <Team />
        <Approach />
        <CaseHighlights />
        <Reviews />
        <Gallery />
        <Blog />
        <Contact />
      </main>
      <Footer />
      <Toaster
        theme="dark"
        position="bottom-right"
        toastOptions={{
          style: {
            background: "#121212",
            border: "1px solid #262626",
            color: "#F7F5F2",
            fontFamily: "Manrope, sans-serif",
          },
        }}
      />
    </div>
  );
}

export default App;
